/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const LightningBoltThinBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.63 19.793c-.267.414-.912.155-.815-.327l1.232-6.132H7.483a.445.445 0 0 1-.376-.684l5.43-8.443c.267-.414.913-.156.816.327l-1.233 6.132h3.564c.353 0 .567.388.376.684l-5.43 8.443Zm3.942-11.127.752-3.74c.533-2.651-3.014-4.074-4.48-1.797l-5.43 8.443c-1.047 1.627.128 3.762 2.07 3.762h1.111l-.752 3.74c-.532 2.651 3.015 4.074 4.48 1.797l5.43-8.443c1.047-1.627-.127-3.762-2.07-3.762h-1.11Z" /></svg>);
const LightningBoltThin = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={LightningBoltThinBase} {...rest} ref={ref} />);
export default LightningBoltThin;